import { Subject } from 'rxjs';
import { IModelChanged } from 'app/logger/logger.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ModelChangeService {

    public modelChanged$: Subject<IModelChanged[]> = new Subject<IModelChanged[]>();

}
